import React, {PureComponent} from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import id from "@irati/utils/id"
import pluralise from "@irati/utils/grammar/pluralise"
import firstnameLastname from "@irati/identity/helpers/user/firstnameLastname"

import Tooltip, {Tip} from "../shared/Tooltip"
import Leader from "./Leader"
import Plus from "./Plus"

const Container = styled.div`
  display: flex;
  ${({align}) => align === "center" && "justify-content: center;"}
  ${({align}) => align === "left" && "justify-content: flex-start;"}
  ${({align}) => align === "right" && "justify-content: flex-end;"}
`

const StyledLeader = styled(Leader)`
  margin: 0 5px;
`

const StyledPlus = styled(Plus)`
  margin: 0 5px;
`

class Leaderboard extends PureComponent {
  static propTypes = {
    poll: PropTypes.object.isRequired,
    count: PropTypes.number,
    align: PropTypes.string,
    className: PropTypes.string,
    size: PropTypes.number,
    showMobileTooltip: PropTypes.bool
  }

  static defaultProps = {
    id: "leaderboard",
    count: 3,
    align: "center",
    className: null,
    size: 50,
    showMobileTooltip: true
  }

  getUsers = () => {
    const {poll} = this.props

    const votesArray = []
    const votes = {}
    poll.votes.results.forEach((vote) => {
      const userId = vote.user.uuid
      if (!votes[userId]) {
        const obj = {user: vote.user, votes: 0}
        votesArray.push(obj)
        votes[userId] = obj
      }
      votes[userId].votes++
    })

    return votesArray.sort((a, b) => {
      return b.votes - a.votes
    })
  }

  getTooltipForUser = (user, votes) => {
    const name = firstnameLastname(user)
    return (
      <Tip id={id(`tooltip_${name}`, this.props)}>
        {name} ({this.pluraliseVotes(votes)})
      </Tip>
    )
  }

  pluraliseVotes = (count) => {
    return `${count} ${pluralise("vote", count)}`
  }

  getPlusTooltip = (users) => {
    const {count} = this.props
    return (
      <Tip id={id("leaderBoardPlusTooltip", this.props)}>
        {users.slice(count, users.length).map(({user, votes}) =>
          <div key={user.uuid}>{firstnameLastname(user)} ({this.pluraliseVotes(votes)})</div>
        )}
      </Tip>
    )
  }

  render() {
    const {align, size, count, className, showMobileTooltip} = this.props
    const users = this.getUsers()

    return (
      <Container align={align} className={className}>
        {users.slice(0, count).map(({user, votes}, i) =>
          <Tooltip key={user.uuid} placement="bottom" tip={this.getTooltipForUser(user, votes)} showMobile={showMobileTooltip}>
            <div>
              <StyledLeader
                id={id(`leader_${i}`, this.props)}
                size={size}
                user={user}
                rank={i + 1} />
            </div>
          </Tooltip>
        )}
        {users.length > count &&
          <Tooltip placement="bottom" tip={this.getPlusTooltip(users)} showMobile={showMobileTooltip}>
            <div>
              <StyledPlus
                id={id("leader_rest", this.props)}
                count={users.length - count}
                size={size} />
            </div>
          </Tooltip>
        }
      </Container>
    )
  }
}

export default Leaderboard
